import moment from 'moment'

import listStyles from '../UploadLogs.module.scss'
import { ReactComponent as Download } from './download.svg'
import styles from './UploadLogRow.module.scss'

const UploadLogsRow = ({
  uploadedByName,
  uploadedOn,
  numberOfTotalRecords,
  numberOfNewSubscribers,
  numberOfUnUsableData,
  numberOfDuplicates,
  numberOfUpdatedSubscribers,
  uploadStatus,
  completedOn,
  numberOfRecordsInProgress,
  inviteUploadHistoryId,
  handleDownloadData,
  uploadHistoryKind,
  numberOfConversions,
  isAdminMode,
  beginDate,
  endDate,
  reportKind,
  category
}) => {
  const overwrittenUploadHistoryKind =
    category === 'EnrichBookings' ? 'EnrichBookings' : uploadHistoryKind

  // .filter(log => log.category = 'ReservationOnlyActivity')
  // numberOfRecordsInProgress of (total - duplicate)

  return (
    <div className={styles.row}>
      <div className={[listStyles.uploadTimeCol, styles.col].join(' ')}>
        <span>{moment(uploadedOn).format('MMM D')}</span>
        <small>{moment(uploadedOn).format('hh:mm A')}</small>
      </div>
      {/* <div className={[listStyles.uploadedByCol, styles.col].join(' ')}>
        <span title={uploadedByName}>{uploadedByName}</span>
      </div> */}
      <div className={[listStyles.timeRangeCol, styles.col].join(' ')}>
        <span>
          {moment(beginDate).format('MMM D YYYY')} -{' '}
          {moment(endDate).format('MMM D YYYY')}
        </span>
        <small title={uploadedByName}>
          {numberOfConversions
            ? `${numberOfConversions} conversions`
            : reportKind === 'Unknown'
            ? 'Custom reports'
            : reportKind}
        </small>
      </div>
      <div className={[listStyles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfTotalRecords}
      </div>
      <div className={[listStyles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfNewSubscribers}
      </div>
      <div className={[listStyles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfUpdatedSubscribers}
      </div>
      <div className={[listStyles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfDuplicates}
      </div>
      <div className={[listStyles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfUnUsableData}
      </div>
      <div className={[listStyles.statusCol, styles.col].join(' ')}>
        <span className={styles[uploadStatus]}>
          <span>
            {uploadStatus === 'Started' && 'In progress'}
            {uploadStatus === 'Finished' && 'Completed'}
            {uploadStatus === 'Cancelled' && 'Cancelled'}
          </span>
          {uploadStatus === 'Finished' && (
            <small>{moment(completedOn).format('MMM D, hh:mm A')}</small>
          )}
          {uploadStatus === 'Started' && (
            <small>{numberOfRecordsInProgress} remaining</small>
          )}
        </span>
      </div>
      <div className={[listStyles.downloadCol, styles.col, styles.downloadCol].join(' ')}>
        {isAdminMode ? (
          <div className={styles.downloadColAdmin}>
            <button
              onClick={() =>
                handleDownloadData(
                  inviteUploadHistoryId,
                  overwrittenUploadHistoryKind,
                  'Denied'
                )
              }
            >
              Invalid
            </button>
            <button
              onClick={() =>
                handleDownloadData(
                  inviteUploadHistoryId,
                  overwrittenUploadHistoryKind,
                  'Accepted'
                )
              }
            >
              Accepted
            </button>
            <button
              onClick={() =>
                handleDownloadData(
                  inviteUploadHistoryId,
                  overwrittenUploadHistoryKind,
                  'OriginalUpload'
                )
              }
            >
              Original - {inviteUploadHistoryId}
            </button>
          </div>
        ) : (
          numberOfUnUsableData > 0 && (
            <button onClick={() => handleDownloadData(inviteUploadHistoryId, 'Denied')}>
              <Download />
              Invalid data
            </button>
          )
        )}
      </div>
    </div>
  )
}

export default UploadLogsRow
